export default "__VITE_ASSET__BeuKf6IR__"